// Microtask-batched id resolver. Each load() returns a promise; all calls made
// inside the same microtask are flushed as a single batchFetch(ids) call.
// batchFetch must return Map<id, value> or { [id]: value }.

const DEFAULT_MAX_BATCH = 200;

export const createDataLoader = ({ batchFetch, maxBatch = DEFAULT_MAX_BATCH }) => {
  let pending = new Map();
  let scheduled = false;

  const flush = async () => {
    const current = pending;
    pending = new Map();
    scheduled = false;

    const ids = Array.from(current.keys());
    const slices = [];
    for (let i = 0; i < ids.length; i += maxBatch) slices.push(ids.slice(i, i + maxBatch));

    await Promise.all(
      slices.map(async slice => {
        try {
          const result = await batchFetch(slice);
          const get = id => (result instanceof Map ? result.get(id) : result?.[id]);
          slice.forEach(id => current.get(id).forEach(({ resolve }) => resolve(get(id))));
        } catch (err) {
          slice.forEach(id => current.get(id).forEach(({ reject }) => reject(err)));
        }
      })
    );
  };

  const load = id =>
    new Promise((resolve, reject) => {
      const entry = pending.get(id) || [];
      entry.push({ resolve, reject });
      pending.set(id, entry);
      if (!scheduled) {
        scheduled = true;
        queueMicrotask(flush);
      }
    });

  return { load };
};
